if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

				// Re-filter the variant description whenever the shopper changes a
				// variant while this modal is open (see filterVariantDescription).
				document.addEventListener("variant:change", (event) => {
					if (!this.hasAttribute("open")) return;
					const formElement = event.detail && event.detail.formElement;
					if (formElement && !this.modalContent.contains(formElement)) return;
					this.filterVariantDescription();
				});
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
				this.modalContent.innerHTML = "";

				$(".js-media-list").each(function () {
					this.swiper.destroy();
				});
				$(".js-media-sublist").each(function () {
					this.swiper.destroy();
				});

				subSliderInit(true);
				sliderInit(true);
				updatethumbnail();

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				this.addEventListener(
					"transitionend",
					() => {
						//const containerToTrapFocusOn = document.getElementById(
						//	opener.getAttribute("data-modal-open")
						//);
						const containerToTrapFocusOn = this;
						const focusElement = this.querySelector(".quick-add-modal__content");
						trapFocus(containerToTrapFocusOn, focusElement);
					},
					{ once: true }
				);

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				// Products can use a landing-page template (hook, FAQ, founder note…),
				// so always render the lean templates/product.quick-add.json here.
				const productUrl = new URL(
					opener.getAttribute("data-product-url"),
					window.location.origin
				);
				productUrl.searchParams.set("view", "quick-add");

				fetch(productUrl.toString())
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener
						);
						// Only the section's contents are copied, so carry its layout class
						// across: product-landing.css (the product pages' styling) keys off it.
						this.modalContent.classList.toggle(
							"product-landing",
							this.productElement.classList.contains("product-landing")
						);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						this.filterVariantDescription();
						super.show(opener);

						$(".product-form__input--dropdown").each(function () {
							const elListItem = $(this).find(".dropdown-select ul li");
							const elItem = $(this).find(".dropdown-select ul");
							const selectedText = $(this).find(
								".dropdown-select .select-label"
							);

							selectedText.on("click", function (e) {
								elItem.toggleClass("active");
								if (elItem.hasClass("active")) {
									e.stopPropagation();
									$(document).click(function () {
										elItem.removeClass("active");
									});
								}
							});

							elListItem.on("click", function () {
								selectedText.text($(this).text()).attr("title", $(this).text());
								elItem.removeClass("active");
								document.activeElement.blur();
							});
						});
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						document.querySelector("cart-drawer")?.classList.remove("active");

						subSliderInit(true, 5, 12);
						sliderInit();
						updatethumbnail();
					});
			}

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});

				// Read more button
				const moreBtn = document.createElement("div");
				moreBtn.setAttribute("class", "button-view-full");
				moreBtn.innerHTML += `
					<a href="${opener.getAttribute(
						"data-product-url"
					)}" class="button button--simple button--small">
						<span class="button-label">
							${theme.quickviewMore}
						</span>
						
					</a>
					`;

				element.querySelector(".product__info-wrapper").appendChild(moreBtn);
			}

			removeDOMElements() {
				const pickupAvailability = this.productElement.querySelector(
					"pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const productModal = this.productElement.querySelector("product-modal");
				if (productModal) productModal.remove();

				const gift = this.productElement.querySelector(".customer");
				if (gift) gift.remove();

				// The mobile sticky add-to-cart bar ships inside the MainProduct
				// section; without its CSS/JS it renders as a dead duplicate
				// "Add to Cart" inside this modal, so strip it.
				const stickyAtc = this.productElement.querySelector(".sticky-atc");
				if (stickyAtc) stickyAtc.remove();

				// The buy-buttons block wrapper is exactly as tall as the form, which
				// pins position:sticky in place. display:contents makes the tall info
				// column the sticky containing block so the add-to-cart area can pin
				// to the bottom of the modal (see .quick-add-modal product-form CSS).
				const productForm = this.productElement.querySelector("product-form");
				if (productForm && productForm.parentElement)
					productForm.parentElement.style.display = "contents";
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			// The "Variant Descriptions King" app only loads on the product page, so
			// inside this modal the raw product description leaks through — showing
			// every variant's copy at once. The description is authored with "#..."
			// headings (e.g. "#1Pack", "#3Pack"), each marking a section tied to an
			// option value. Here we show only the section(s) matching the currently
			// selected variant, mirroring what the app does on the product page.
			filterVariantDescription() {
				const description = this.modalContent.querySelector(
					".product__description-fixed, .main-product-description"
				);
				if (!description) return;

				const normalize = (value) =>
					(value || "").toString().replace(/[^a-z0-9]/gi, "").toLowerCase();

				// Every option value this product offers (e.g. "1 Pack", "3 Pack"),
				// used to tell a variant heading apart from an ordinary heading.
				const optionTokens = new Set();
				this.modalContent
					.querySelectorAll(
						".product-form__input input[value], variant-selects option[value]"
					)
					.forEach((el) => optionTokens.add(normalize(el.value)));

				// The option values currently selected in the modal.
				const selectedTokens = new Set();
				this.modalContent
					.querySelectorAll(".product-form__input input:checked")
					.forEach((el) => selectedTokens.add(normalize(el.value)));
				this.modalContent
					.querySelectorAll("variant-selects select, .product-form__input select")
					.forEach((el) => selectedTokens.add(normalize(el.value)));

				// Group the description's nodes: a heading whose text matches an option
				// value starts a new variant section; following nodes belong to it.
				let activeGroup = null;
				const groups = [];
				Array.from(description.children).forEach((node) => {
					const isHeading = /^H[1-6]$/.test(node.tagName);
					const token = isHeading ? normalize(node.textContent) : null;

					if (isHeading && optionTokens.has(token)) {
						activeGroup = { token, heading: node, body: [] };
						groups.push(activeGroup);
					} else if (activeGroup) {
						activeGroup.body.push(node);
					}
				});

				// No variant-specific headings — leave the description untouched.
				if (!groups.length) return;

				groups.forEach((group) => {
					const show = selectedTokens.has(group.token);
					// The "#..." heading is only a marker and is never displayed.
					group.heading.style.display = "none";
					group.body.forEach((node) => {
						node.style.display = show ? "" : "none";
					});
				});
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}
